import React from "react";
import "../styles/CarpetPricing.css";
import { useRef } from "react";
import { useEffect } from "react";

const rate = 30; // KSh per sq ft
const FT_TO_M = 0.3;

const carpets = [
  { width: 5, height: 8 },
  { width: 6, height: 10 },
  { width: 7, height: 10 },
  { width: 8, height: 11 },
  { width: 9, height: 12 },
];

const CarpetPricing = () => {

 const servicesRef = useRef(null);

useEffect(() => {
  const revealElements =
    servicesRef.current?.querySelectorAll("[data-reveal]") || [];

  const scrollReveal = () => {
    revealElements.forEach((el) => {
      const elementIsInScreen =
        el.getBoundingClientRect().top < window.innerHeight / 1.15;

      if (elementIsInScreen) {
        el.classList.add("revealed");
      } else {
        el.classList.remove("revealed");
      }
    });
  };

  window.addEventListener("scroll", scrollReveal);
  scrollReveal(); // run on load

  return () => {
    window.removeEventListener("scroll", scrollReveal);
  };
}, []);

  return (
    <section className="carpet-section" ref={servicesRef}>
      <div className="carpet-section-header">
        <span data-reveal>our price list</span>
        <h2 className="carpet-title" data-reveal>Carpet Price List</h2>
      </div>

      <div className="table-wrapper">
        <table className="carpet-table">
          <thead>
            <tr>
              <th>Size (ft)</th>
              <th>Size (m)</th>
              <th>Price (KSh)</th>
            </tr>
          </thead>

          <tbody>
            {carpets.map((item, index) => {
              const area = item.width * item.height;
              const price = area * rate;

              // Convert to meters
              const widthM = (item.width * FT_TO_M).toFixed(1);
              const heightM = (item.height * FT_TO_M).toFixed(1);

              return (
                <tr key={index}>
                  <td>{item.width} x {item.height}</td>
                  <td>{widthM} x {heightM}</td>
                  <td>KSh {price.toLocaleString()}</td>
                </tr>
              );
            })}

            <tr>
              <td>Extra Large</td>
              <td>Above 2.7 x 3.6 m</td>
              <td>KSh 30 / sq ft</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default CarpetPricing;